import { useState, createContext } from 'react'

export const LeftPanelVisibleContext = createContext<any>(null);

const LeftPanelVisibleProvider = ({ children }: any) => {

    const [leftVisible, setLeftVis] = useState<boolean>(true)

    return (
        <LeftPanelVisibleContext.Provider value={{ leftVisible, setLeftVis }} >
            {children}
        </LeftPanelVisibleContext.Provider>
    )
}

export default LeftPanelVisibleProvider;